export default __webpack_public_path__ + "8a7d6fa5eb4478b298986323f292008a.png";